import { useFormik } from "formik";
import React, { useState } from "react";
import * as Yup from "yup";
import { httpReauest } from "../../../utils/httpRequest";
import { toast } from "react-toastify";
import { FaCheckCircle, FaRegCheckCircle } from "react-icons/fa";
import { toEnglishDigits } from "../mobile/ProductsMobile";

const RequestBuy = ({ full }) => {
  const [approveStep, setApproveStep] = useState();
  const [submited, setsubmited] = useState(false);

  const VALUE_SIGN_VALIDATION = () => {
    return Yup.object({
      phone: Yup.number()
        .typeError("باید شماره باشد")
        .min(1000000000, "شماره تلفن باید 11 رقم باشد")
        .max(9999999999, "شماره تلفن باید 11 رقم باشد")
        .required("الزامی است"),
      userType: Yup.string().required("الزامی است"),
      vehicle: Yup.string().required("الزامی است"),
    });
  };
  const formik = useFormik({
    initialValues: { userType: "", phone: "", vehicle: "", acceptCode: "" },
    validationSchema: VALUE_SIGN_VALIDATION,
    onSubmit: async (values) => {
      await httpReauest("POST", "/request/buy-sell", values, {})
        .then(({ status }) => {
          if (status === 201) {
            setApproveStep(true);
          }
        })
        .catch((err) => {
          toast.error(err.response?.data?.message);
        });
    },
  });

  async function handleSubmit() {
    await httpReauest(
      "POST",
      "/request/buy-sell/accept",
      { phone: formik.values.phone, code: formik.values.acceptCode },
      {}
    )
      .then(({ status }) => {
        if (status === 201) {
          toast.success("اطلاعات شما ثبت شد");
          setsubmited(true);
        }
      })
      .catch((err) => {
        toast.error(err.response?.data?.message);
      });
  }

  return (
    <form
      onSubmit={formik.handleSubmit}
      className="w-full border-brand relative p-4 2xl:p-6 flex items-center justify-between 2xl:gap-4 gap-2"
    >
      {submited ? (
        <div className="w-full flex justify-center">
          <FaRegCheckCircle className="text-green-600" size={30} />
        </div>
      ) : approveStep ? (
        <>
          <span className="flex items-center gap-3">
            <p className="text-[18px] font-bold">تایید شماره تلفن ثبت شده</p>
          </span>
          <span className="relative">
            <input
              className={`w-full form-brand `}
              placeholder=""
              id="acceptCode"
              value={formik.values.acceptCode}
              name="acceptCode"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            <p className="on-border">کد ارسال شده</p>
          </span>
          <span className="flex justify-end ">
            <button
              type="button"
              onClick={handleSubmit}
              className={`${
                full ? "min-w-[280px]" : "min-w-[193px]"
              } btn-brand`}
            >
              تایید
            </button>
          </span>
        </>
      ) : (
        <>
          <h2 className="text-[20px] text-[#F42A1C] font-[700]">
            خرید و فروش فوری
          </h2>
          <span className="flex items-center gap-3">
            <input
              type="radio"
              id="userType"
              value={"seller"}
              name="userType"
              onChange={formik.handleChange}
              className="w-[15px] h-[15px] rounded-full rounded-checkbox"
            />
            <p className="text-[14px] 2xl:text-[16px]">فروشنده هستم</p>
          </span>
          <span className="flex items-center gap-3">
            <input
              type="radio"
              id="userType"
              value={"buyyer"}
              name="userType"
              onChange={formik.handleChange}
              className="w-[15px] h-[15px] rounded-full rounded-checkbox"
            />
            <p className="text-[14px] 2xl:text-[16px]">خریدار هستم</p>
          </span>
          <span className="relative">
            <input
              className={`${
                full ? "2xl:min-w-[300px]" : "2xl:min-w-[193px]"
              } w-full form-brand `}
              placeholder="مثلا : بنز باری 10 تن مدل 1380"
              id="vehicle"
              value={formik.values.vehicle}
              name="vehicle"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            <p className="on-border">خودرو</p>
            {formik.errors.vehicle && formik.touched.vehicle && (
              <p style={{ color: "red", fontSize: "14px" }}>
                {formik.errors.vehicle}
              </p>
            )}
          </span>
          <span className="relative">
            <input
              className={`${
                full ? "2xl:min-w-[300px]" : "2xl:min-w-[193px]"
              } w-full form-brand `}
              placeholder="09151234567"
              id="phone"
              value={formik.values.phone}
              name="phone"
              onChange={(e) =>
                formik.setFieldValue("phone", toEnglishDigits(e.target.value))
              }
              onBlur={formik.handleBlur}
            />
            {formik.errors.phone && formik.touched.phone && (
              <p style={{ color: "red", fontSize: "14px" }}>
                {formik.errors.phone}
              </p>
            )}
            <p className="on-border">تلفن همراه</p>
          </span>
          <span className="flex justify-end ">
            <button
              type="submit"
              className={`${
                full ? "2xl:min-w-[280px]" : "2xl:min-w-[193px]"
              } btn-brand`}
            >
              ثبت درخواست
            </button>
          </span>
        </>
      )}
    </form>
  );
};

export default RequestBuy;
